import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app.config';
import { AppComponent } from './app.component';
import { Amplify } from 'aws-amplify';
import { environment } from './environments/environment';

// Intenta configurar Amplify justo antes del bootstrap
try {
  Amplify.configure(environment.awsConfig);
} catch (error) {
  console.error('Error configurando Amplify:', error);
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error('Error en bootstrap:', err));
